import { usePromptToolboxContext } from '@Context/prompt-toolbox/PromptToolboxContext';
import { useUtilityContext } from '@Context/prompt-toolbox/UtilityContext';
import { LibraryPrompt } from '@Models/types';
import { MoonLoader } from 'react-spinners';
import LibraryTile from './LibraryTile';
import { useAuth } from '@Context/CognitoAuthProvider';
interface Props {
  prompts: LibraryPrompt[];
}

const LibraryList: React.FC<Props> = ({ prompts }) => {
  const { user } = useAuth();
  const { selectedLibrary, setSelectedLibrary } = usePromptToolboxContext();
  const { loaders } = useUtilityContext();

  const selectLibrary = (library: LibraryPrompt) => {
    if (selectedLibrary.some((s) => s._id === library._id)) {
      const filter = selectedLibrary.filter((i) => i._id !== library._id);
      setSelectedLibrary(filter);
    } else {
      setSelectedLibrary((prev) => [library, ...prev]);
    }
  };

  return (
    <div className="custom-scroll flex h-full w-full flex-col gap-y-1 overflow-y-auto p-2">
      {loaders.libraryPrompts ? (
        <span className="flex h-full w-full flex-col items-center justify-center gap-y-6 p-5">
          <MoonLoader size={150} color="#071D49" />
          <span className="animate-pulse text-xs font-semibold tracking-wide text-gray-600">
            Library Prompts Loading
          </span>
        </span>
      ) : (
        <>
          {prompts.map((prompt, index) => (
            <LibraryTile
              key={`library-time-${index}`}
              prompt={prompt}
              index={index}
              selectedLibrary={selectedLibrary}
              onSelect={() => selectLibrary(prompt)}
              isAdmin={user ? user.admin : false}
            />
          ))}
        </>
      )}
    </div>
  );
};

export default LibraryList;
